import { appBannerAction } from '../action/appBannerAction';
import { history } from '../constants/router';
import DOMPurify from 'dompurify';
import { get } from 'lodash';

export class AppBannerService {

  /** @type {AppBannerService} */
  static instance;

  static getInstance() {
    if (!AppBannerService.instance) {
      AppBannerService.instance = new AppBannerService();
    }
    return AppBannerService.instance;
  }

  contentUpdateTimerId;

  _bannerContent;

  dispose = () => {
    if (this.contentUpdateTimerId) {
      window.clearTimeout(this.contentUpdateTimerId);
      this.contentUpdateTimerId = null;
    }

    this._bannerContent = null;
    if (this.removeRouteChangeListener) {
      this.removeRouteChangeListener();
      this.removeRouteChangeListener = null;
    }
  }

  async init() {
    await this.getContent();
    this.applyContent();
  }

  getContent = async () => {
    let bannerData = await appBannerAction.getBannerData();
    bannerData = get(bannerData, 'message');

    if (!bannerData || !bannerData.expiresIn) {
      this.dispose();
    }

    this.contentUpdateTimerId = window.setTimeout(this.refreshContent, this.secondToMs(bannerData.expiresIn));
    if (this.hasContent(bannerData)) {
      this._bannerContent = DOMPurify.sanitize(bannerData.content, { FORCE_BODY: true });
    } else {
      this._bannerContent = null;
    }
  }

  refreshContent = async () => {
    await this.getContent();
    this.setRouteChangeListener();
  }

  applyContent = () => {
    appBannerAction.setBannerContent(this._bannerContent);
    if (this.removeRouteChangeListener) {
      this.removeRouteChangeListener();
    }
  }

  setRouteChangeListener = () => {
    if (this.removeRouteChangeListener) {
      this.removeRouteChangeListener();
    }
    this.removeRouteChangeListener = history.listen(this.applyContent);
  }

  removeRouteChangeListener;

  hasContent(bannerData) {
    return Boolean(bannerData && bannerData.content);
  }

  secondToMs(s) { return s * 1000; }

}
